<template>
<!--    <v-dialog>-->
    <div class="background" v-if="isShow">
        <v-progress-circular
                class="progress"
                size="90"
                indeterminate
                color="lime"
        >
            loading ..
        </v-progress-circular>

    </div>

</template>

<script>
export default {
    props: {
        isShow: Boolean,
    },
}
</script>

<style>
    .background{
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        z-index:9998;
        background-color:rgba(0,0,0,.5);
    }
    .background .progress {
        /*display: inline-block;*/
        position: absolute;
        top: 50%;
        left: 50%;
        margin:-45px 0 0 -45px;
        z-index:9999;
    }
</style>